module.exports = __webpack_public_path__ + "media/old_images/search-shape@2x-9142023f.png";